import React from "react";
import { Spin, Typography } from "antd";
import { TrapStatusData } from "../../types";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import AlertDialog from "./AlertDialog";
import "./index.css";

const { Title } = Typography;

type Props = {
  loading: boolean;
  listContainerRef: React.RefObject<HTMLDivElement>;
  trapStatusData: TrapStatusData[];
  handleClickDialog: (id: string) => void;
};

const TrapStatus: React.FC<Props> = ({
  loading,
  listContainerRef,
  trapStatusData = [],
  handleClickDialog,
}) => {
  return (
    <div className="trap-status-dialog">
      <Spin spinning={loading}>
        <div className="trap-status-dialog-title">
          <Title level={4} className="trap-status-dialog-title-text">
            Trap Status
          </Title>
          <ChevronDownIcon className="w-6 h-6 text-[#003A55]" />
        </div>
        <div
          ref={listContainerRef}
          className={`trap-status-dialog-alerts ${
            trapStatusData.length > 0 ? "has-alerts" : "no-alerts"
          }`}
        >
          {trapStatusData.length > 0 &&
            trapStatusData.map((item: TrapStatusData) => (
              <AlertDialog
                key={item._id}
                item={item}
                onClick={handleClickDialog}
              />
            ))}
        </div>
      </Spin>
    </div>
  );
};

export default TrapStatus;
